import React, { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import KeywordCard from "./keywordCard";
import { PREDEFINED_SEARCH_KEYWORDS } from "helpers/constants";

type KeywordsContainerPropsType = {
  category: string;
  handleSelect: (keyword: string) => void;
  className?: string;
  searchText: string;
};
function KeywordsContainer({
  category,
  handleSelect,
  searchText,
  className = "",
}: KeywordsContainerPropsType) {
  const [selectedkeyword, setSelectedKeyword] = useState<string>();
  const { t: translate } = useTranslation("categories");
  useEffect(() => {
    if (!searchText) {
      setSelectedKeyword("");
    }
  }, [searchText]);

  if (!category) {
    return null;
  }
  return (
    <div className={`flex flex-wrap justify-center  gap-x-3 gap-y-2 ${className}`}>
      {PREDEFINED_SEARCH_KEYWORDS[category].map((keyword: string) => {
        const translatedKeyword = translate(`predefined_search_keywords.${category}.${keyword}`);
        return (
          <KeywordCard
            key={keyword}
            keyword={translatedKeyword}
            isSelected={selectedkeyword === keyword}
            handleSelect={() => {
              if (keyword === selectedkeyword || searchText.includes(keyword)) return;
              setSelectedKeyword(keyword);
              handleSelect(translatedKeyword);
            }}
          />
        );
      })}
    </div>
  );
}

export default KeywordsContainer;
